module.exports = __webpack_public_path__ + "img/mena-man.0afdd9ad.svg";